import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import contents from '../../routes/contentRoutes';

const UNDER_DEVELOPMENT = lazy(() => import('../../pages/presentation/page-layouts/OnlyHeader'));
const ContentRoutes = () => {
	return (
		<Routes>
			{contents.map((page) => (
				// eslint-disable-next-line react/jsx-props-no-spreading
				<Route key={page.path} {...page} />
			))}
			<Route path='*' element={<UNDER_DEVELOPMENT />} />
		</Routes>
	);
};

export default ContentRoutes;
